import { createContext } from 'react'
export const AppConfigContext = createContext<any>({})

const AppConfigProvider = ({ config, children }: any) => {
  return <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>
}

export default AppConfigProvider
